import { $win } from '../utils/globals';

$win.on('load', function () {
  $('.js-collection-description .section__entry iframe').wrap('<div class="video">');
});
